"use client";

import { defaultTransitionDurationMs, OnCardClick } from "@kyan/ui";
import { useState } from "react";

export const useOpenCardIds = <T extends object>() => {
  const [openCardIds, setOpenCardIds] = useState<string[]>([]);

  const onCardClick: OnCardClick<T> = ({ cardId }) => {
    setOpenCardIds((previous) => {
      if (previous.includes(cardId)) {
        return previous.filter((id) => id !== cardId);
      }

      return [...previous, cardId];
    });

    setTimeout(() => {
      const element = document.getElementById(cardId);
      element?.parentElement?.scrollIntoView({
        behavior: "smooth",
        block: "nearest",
      });
    }, defaultTransitionDurationMs); // Delay should match the animation duration of the card expansion
  };

  return {
    openCardIds,
    onCardClick,
  };
};
